(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["scroll-locked-reveal"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const trigger = document.querySelector('.scroll-lock-trigger');
  const section = trigger.querySelector('.scroll-lock-gallery');
  const track = section.querySelector('.slg-track');
  const slides = section.querySelectorAll('.slg-slide');
  if (!slides.length) return;

  const isVertical = section.classList.contains('is-vertical');
  const secH = section.getBoundingClientRect().height;
  const total = slides.length;
  let scrollLen = secH * (total - 1);
  trigger.style.height = `${scrollLen + secH}px`;

  function onScroll() {
    const start = trigger.offsetTop;
    const end = start + scrollLen;
    const y = window.scrollY;

    if (y >= start && y <= end) {
      const progress = (y - start) / scrollLen;
      if (isVertical) {
        const shiftPx = progress * (total - 1) * secH;
        track.style.transform = `translate3d(0, -${shiftPx}px, 0)`;
      } else {
        const shiftVW = progress * 100 * (total - 1);
        track.style.transform = `translate3d(-${shiftVW}vw, 0, 0)`;
      }
      const i = Math.round(progress * (total - 1));
      slides.forEach((s, idx) => s.classList.toggle('active', idx === i));
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-scroll-animation"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const track = document.querySelector('.scroll-collections__track');
  if (!track) return;

  const inner = track.querySelector('.scroll-collections__inner');
  const baseSpeed = parseFloat(track.dataset.speed) || 40;
  const direction = track.dataset.direction || 'left';
  let scrollPos = 0, velocity = 0, isDragging = false, startX = 0, dragStart = 0;

  track.addEventListener('mousedown', e => {
    isDragging = true;
    startX = e.pageX;
    dragStart = scrollPos;
    track.classList.add('dragging');
    e.preventDefault();
  });

  window.addEventListener('mouseup', () => {
    isDragging = false;
    track.classList.remove('dragging');
  });

  window.addEventListener('mousemove', e => {
    if (!isDragging) return;
    e.preventDefault();
    const dx = e.pageX - startX;
    scrollPos = dragStart + dx;
    inner.style.transform = `translateX(${scrollPos}px)`;
  });

  // --- Touch drag ---
  track.addEventListener('touchstart', e => {
    isDragging = true;
    startX = e.touches[0].pageX;
    dragStart = scrollPos;
    track.classList.add('dragging');
  });

  window.addEventListener('touchend', () => {
    isDragging = false;
    track.classList.remove('dragging');
  });

  track.addEventListener('touchmove', e => {
    if (!isDragging) return;
    e.preventDefault();
    const dx = e.touches[0].pageX - startX;
    scrollPos = dragStart + dx;
    inner.style.transform = `translateX(${scrollPos}px)`;
  });

  track.addEventListener('wheel', e => {
    e.preventDefault();
    const delta = e.deltaY || e.wheelDelta;
    velocity += delta * 0.4;
  }, { passive: false });

  function animate() {
    velocity *= 0.95;
    scrollPos += (direction === 'left' ? -1 : 1) * (velocity / 30 + baseSpeed / 200);
    inner.style.transform = `translateX(${scrollPos}px)`;

    const resetPoint = inner.scrollWidth / 2;
    if (direction === 'left') {
      if (scrollPos < -resetPoint) scrollPos = 0;
    } else {
      if (scrollPos > 0) scrollPos = -resetPoint;
    }
    requestAnimationFrame(animate);
  }

  animate();
});

  } catch(e) { console.error(e); }
})();
})();
